export const asszisztensNaptar = {
  title: "Assistant Calendar",
  chat: {
    title: "Calendar Assistant",
    placeholder: "E.g: 'Add a meeting for Anna on Friday at 2pm'",
    welcomeMessage: "Hi! I'll help you edit the calendar. Tell me what you'd like to do!",
    examples: {
      title: "Examples:",
      addAppointment: "Add a meeting tomorrow at 10am for Peter",
      moveAppointment: "Move Tuesday's meeting to Wednesday",
      deleteAppointment: "Delete Anna's Friday appointment",
      checkAvailability: "When is Peter available next week?"
    }
  },
  calendar: {
    title: "Team Calendar",
    weekView: "Week View",
    todayButton: "Today",
    previousWeek: "Previous week",
    nextWeek: "Next week",
    noAppointments: "No appointments for this day",
    teamMembers: "Team Members"
  },
  staff: {
    anna: "Anna",
    peter: "Peter",
    eva: "Eva",
    markus: "Marcus"
  },
  appointmentTypes: {
    meeting: "Meeting",
    consultation: "Consultation",
    training: "Training",
    break: "Break",
    appointment: "Appointment"
  }
};